/**
 * MyDashboard — Monday-style customizable widget dashboard (Phase 5, 2026-05-16).
 *
 * Każdy user ma własny układ widgetów (drag + resize). 8 typów widgetów:
 *   - KPI stage counts
 *   - KPI total value
 *   - Activity feed (live)
 *   - Activity stats (7d)
 *   - Recent spec-ins
 *   - Automation runs
 *   - Top patterns (Adam)
 *   - Kanban mini
 *
 * Domyślny layout jest seedowany przy pierwszym wejściu.
 * Reset button przywraca defaultową kompozycję.
 */

import React from 'react';
import { Sparkles } from 'lucide-react';
import WidgetGrid from '../components/dashboard/WidgetGrid';
import PlanLock from '../components/common/PlanLock';


export default function MyDashboard({ lang = 'pl' }) {
  return (
    <PlanLock feature="dashboard_widgets" requiredPlan="pro" lang={lang}>
      <div className="p-6 max-w-7xl mx-auto space-y-4">
        <div className="flex items-center gap-2">
          <Sparkles className="w-6 h-6 text-amber-300" />
          <div>
            <h1 className="text-2xl font-bold">Mój Dashboard</h1>
            <p className="text-sm text-muted-foreground">
              Konfigurowalne widgety — przesuwaj, zmieniaj rozmiar, dodawaj swoje. Tryb "Edytuj" odblokowuje DnD.
            </p>
          </div>
        </div>
        <WidgetGrid />
      </div>
    </PlanLock>
  );
}
